import { useLocation, Link, useParams } from "react-router-dom";
import { ShieldCheck, Home } from "lucide-react";

export default function ScanSuccess() {
  const { state } = useLocation();
  const { cardCode } = useParams();
  const ref = state?.reference;

  return (
    <div className="min-h-screen bg-[#F9F9F8] flex flex-col">
      <header className="bg-[#10B981] text-white py-6">
        <div className="max-w-md mx-auto px-6 text-center">
          <ShieldCheck size={36} className="mx-auto" />
          <div className="font-display font-extrabold text-2xl mt-3">Alert sent</div>
        </div>
      </header>

      <main className="flex-1 max-w-md w-full mx-auto px-6 py-8">
        <div className="card-flat p-6 mb-4" data-testid="success-card">
          <div className="label-eyebrow mb-2">Driver notified</div>
          <h1 className="font-display font-black text-3xl tracking-tight mb-3">Thanks. You helped.</h1>
          <p className="text-gray-600 leading-relaxed mb-4">
            The owner has received your alert with our AI verification. They'll decide and respond shortly. Your phone number is never shared with them.
          </p>
          {ref && (
            <div className="font-mono text-xs text-gray-500 border-t border-gray-200 pt-3">
              Ref: <span className="text-gray-800">{ref}</span>
            </div>
          )}
        </div>

        <Link to="/" className="btn btn-ghost w-full" data-testid="success-home">
          <Home size={16} /> Done
        </Link>
      </main>
    </div>
  );
}
